__webpack_public_path__ = document.getElementById('bundle-script').dataset.assetHostPath
